import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import axios from "config/axiosConfig";
import dateFormat, { masks } from "dateformat";

export default function Detail() {
    const [params, setParams] = useState();

    const [salaries, setSalaries] = useState([]);

    const [inputTargetDate: String, setInputTargetDate] = useState('');
    const [inputImages, setInputImages] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출

    const handleInputImages = (e) => {
        const images = e.target.files;

        let newImages = [...inputImages];
        let baseIndex = newImages.length;
        for (let i = 0; i < images.length; i++) {
            images[i].previewUrl = URL.createObjectURL(images[i]);
            images[i].index = baseIndex + i;
            console.log("images[i].index : " + images[i].index);
            newImages.push(images[i]);
        }

        setInputImages(newImages);
    }

    const handleRemoveImages = (index) => {
        const images = inputImages.filter((item, offset) => offset !== index);
        setInputImages(images);
    }

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onDragEnd = (result) => {
        if (!result.destination) {
            return;
        }

        setInputImages((items) =>
            reorder(items, result.source.index, result.destination.index)
        );
    };

    useEffect(() => {
        setParams({
            bizId: queryParams.get("bizId"),
            bizNo: queryParams.get("bizNo"),
            bizName: queryParams.get("bizName"),
            pageNo: queryParams.get("pageNo") ?? 1,
            searchBizName: queryParams.get("searchBizName") ?? '',
            searchMembership: queryParams.get("searchMembership") ?? '',
        })
        requestSalaries();
    }, []);

    const requestSalaries = () => {
        axios.get("/admin/salary", { params: {bizId: queryParams.get("bizId")}})
            .then(res => {
                console.log(res.data);
                setSalaries(res.data);
            })
            .catch((err) => {
                alert(err.response.data.message);
            })
    }

    const requestSave = () => {
        if (inputTargetDate === '') {
            alert('년월을 선택해주세요.');
            return;
        }

        if (inputImages.length < 1) {
            alert('급여 명세서를 첨부하세요.');
            return;
        }

        const formData = new FormData();
        formData.append("bizId", params.bizId);
        formData.append("yearMonth", dateFormat(inputTargetDate, 'yyyy-mm'));
        inputImages.map((image) => {
            formData.append("files", image);
        })

        axios.post('/admin/salary', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((res) => {
                alert('등록되었습니다.');
                window.location.reload();
            })
            .catch((err) => {
                alert(err.response.data.message);
            });
    }

    const requestDelete = (bizId, yearMonth) => {
        axios.delete('/admin/salary', {params: {bizId: bizId, yearMonth: yearMonth}})
            .then(res => {
                requestSalaries();
            })
    }

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">급여관리 > 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="form-group row">
                                                <label className="col-sm-1 col-form-label">사업장</label>
                                                <div className="col-sm" style={{marginTop: "7px"}}>
                                                    {params && params.bizName} - {params && params.bizNo}
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label htmlFor="targetDate"
                                                       className="col-sm-1 col-form-label">년월</label>
                                                <div style={{width: '245px', marginTop: '2px'}}>
                                                    <DatePicker
                                                        id={'targetDate'}
                                                        showMonthYearPicker={true}
                                                        dateFormat="yyyy-MM"
                                                        dateFormatCalendar="yyyy년"
                                                        locale="ko"
                                                        selected={inputTargetDate}
                                                        onChange={date => setInputTargetDate(date)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-sm-1 col-form-label">파일</label>

                                                <div style={{width: '245px', marginTop: '2px'}}>
                                                    <label htmlFor="input-file" style={{
                                                        padding: "6px 25px",
                                                        background: "lightgray",
                                                        borderRadius: "4px",
                                                        cursor: "pointer"
                                                    }}>파일선택</label>
                                                    <input type="file" id="input-file" multiple accept={"image/*"}
                                                           onChange={handleInputImages} style={{display: "none"}}/>
                                                </div>
                                            </div>

                                            <div className="card">
                                                <div className="card-header">
                                                    <h3 className="card-title">Photos</h3>
                                                </div>
                                                {/* /.card-header */}
                                                <div className="card-body p-0">
                                                    <div className="row mt-4">
                                                        {
                                                            inputImages && (
                                                                <DragDropContext onDragEnd={onDragEnd}>
                                                                    <Droppable droppableId="droppable"
                                                                               direction="horizontal">
                                                                        {(provided) => (
                                                                            <div
                                                                                ref={provided.innerRef}
                                                                                {...provided.droppableProps}
                                                                                style={{
                                                                                    display: "flex",         // Flexbox 사용
                                                                                    gap: "10px",             // 아이템 간 간격
                                                                                    overflowX: "auto",       // 가로 스크롤 활성화
                                                                                }}>
                                                                                {inputImages.map((item, index) => (
                                                                                    <Draggable
                                                                                        key={`item-${item.index}`}
                                                                                        draggableId={`item-${item.index}`}
                                                                                        index={index}>
                                                                                        {(provided) => (
                                                                                            <div
                                                                                                ref={provided.innerRef}
                                                                                                {...provided.draggableProps}
                                                                                                {...provided.dragHandleProps}
                                                                                                style={{
                                                                                                    userSelect: "none",
                                                                                                    padding: "10px 20px",
                                                                                                    margin: "0 5px",
                                                                                                    backgroundColor: "lightgray",
                                                                                                    borderRadius: "8px",
                                                                                                    ...provided.draggableProps.style,
                                                                                                }}>
                                                                                                <div
                                                                                                    style={{marginBottom: '10px'}}>
                                                                                                    <div
                                                                                                        className="position-relative">
                                                                                                        <a href={item.previewUrl}
                                                                                                           target={"_blank"}>
                                                                                                            <img width={300}
                                                                                                                 src={item.previewUrl}/>
                                                                                                        </a>
                                                                                                    </div>
                                                                                                    <div style={{
                                                                                                        marginTop: "10px",
                                                                                                        display: "flex",
                                                                                                        justifyContent: "center"
                                                                                                    }}>
                                                                                                        <div
                                                                                                            style={{marginTop: "3px"}}>{item.name}</div>
                                                                                                        <button
                                                                                                            type="button"
                                                                                                            style={{
                                                                                                                marginLeft: "10px",
                                                                                                                height: "32px"
                                                                                                            }}
                                                                                                            className="btn btn-outline-dark"
                                                                                                            onClick={e => handleRemoveImages(index)}>
                                                                                                            삭제
                                                                                                        </button>
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        )}
                                                                                    </Draggable>
                                                                                ))}
                                                                                {provided.placeholder}
                                                                            </div>
                                                                        )}
                                                                    </Droppable>
                                                                </DragDropContext>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                {/* /.card-body */}
                                            </div>

                                            <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                                <div style={{margin: "0 auto"}}>
                                                    <button type="button" className="btn btn-outline-dark"
                                                            onClick={e => navigate(-1)}>
                                                        취소
                                                    </button>
                                                    <button type="button" className="btn btn-outline-dark"
                                                            onClick={requestSave}>
                                                        저장
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                        <table className="table table-hover text-nowrap"
                               style={{textAlign: "center"}}>
                            <thead>
                            <tr>
                                <th>년월</th>
                                <th>급여</th>
                                <th>관리</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                salaries.map(item => {
                                    return (
                                        <tr key={item.yearMonthly}>
                                            <td>{item.yearMonthly}</td>
                                            <td>
                                                {
                                                    item.salaries.map(salary => {
                                                        return (
                                                            <div style={{display: "inline-block"}}>
                                                                <a href={salary.imageUrl} target={"_blank"}>
                                                                    <img width={100} src={salary.imageUrl} style={{margin: '0 10px'}}/>
                                                                </a>
                                                                <div>{salary.originalName}</div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </td>
                                            <td>
                                                <button type="button"
                                                        className="btn btn-outline-danger btn-sm"
                                                        style={{width: '70px'}}
                                                        onClick={() => requestDelete(params.bizId, item.yearMonthly)}>
                                                    삭제
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}